module.exports = __webpack_public_path__ + "img/C7.ed4f790e.webp";